import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const STR = {
  English: {
    appName: "Agro Madat", tagline: "The farmer's companion, at every step",
    login: "Log in", signup: "Sign up", logout: "Log out", demo: "Try Demo",
    email_phone: "Phone number or Email", password: "Password", name: "Full name",
    google: "Continue with Google", or: "or", welcome: "Welcome back",
    createAccount: "Create your account", dashboard: "Dashboard", land: "Land Mapping",
    crops: "Crop Library", operations: "Operations", planning: "Future Planning",
    resources: "Madat Saathi", inventory: "Inventory", accounting: "Accounting",
    equipment: "Equipment", weather: "Weather", market: "Market", satellite: "Satellite & NDVI",
    analytics: "Analytics", ai: "AI Agronomist", documents: "Documents", crm: "Farm CRM",
    schemes: "Govt Schemes", team: "Team & Roles", export: "Export Center", profile: "Profile",
    overview: "Overview", landCrops: "Land & Crops", resFinance: "Resources & Finance",
    intelligence: "Intelligence", admin: "Admin", totalArea: "Total Area", activeCrops: "Active Crops",
    netPL: "Net Profit/Loss", avgNdvi: "Avg Field Health", goodMorning: "Namaste",
    search: "Search...", addField: "Add Field", startCycle: "Start Crop Cycle",
    logActivity: "Log Activity", askAi: "Ask your farm assistant…", send: "Send",
    acrossFields: "across your fields", growingNow: "growing now", thisSeason: "this season",
    fieldHealthIdx: "field health index", cashflow: "Cashflow", last6Months: "Last 6 months",
    incomeVsExpense: "Income vs Expense", income: "Income", expense: "Expense",
    soilDistribution: "Soil Distribution", acresBySoil: "Acres by soil type",
    activeCropCycles: "Active Crop Cycles", viewAll: "View all", alertsTasks: "Alerts & Tasks",
    yourCropsLive: "Your Crops — Live Mandi", todaysBestRate: "Today's best rate for the crops you grow",
    liveLabel: "Live", sampleLabel: "Sample", noRateToday: "No rate available today", lastPrice: "Last price",
    mandiWatch: "Mandi Watch", sevenDay: "7-day", agriNews: "Agri News", loadingWeather: "Loading weather…",
    loadingPrices: "Loading prices…", humidity: "Humidity", wind: "Wind", rain: "Rain",
    cropSuitability: "Crop Suitability", rotation5yr: "5-Year Rotation", seasonalTab: "This Season",
    longTermTab: "Long-term", scoringCrops: "Scoring crops…", costAcre: "Cost/acre", estProfit: "Est. profit",
    duration: "Duration", months: "mo", marketRisk: "Market risk", riskLow: "Low", riskMedium: "Medium",
    riskHigh: "High", perennialNote: "Perennial — one-time planting", nextService: "Next service",
    hrsToService: "hrs to service", mspBacked: "MSP-backed",
    fasalDoctor: "Fasal Doctor", herbTrace: "Herb Traceability", sinchai: "Irrigation Advisor",
    khaad: "Fertilizer Calc", simulator: "Profit Simulator", pmfby: "PMFBY Claim",
    echarak: "Herbs (e-Charak)", mandiTab: "Mandi", offlineMode: "Offline mode — showing saved data", backOnline: "Back online",
    cropProblems: "Problem Calendar",
    sprayCheck: "Spray Safety",
    reportEvent: "Report Issue",
    madatSaathi: "Madat Saathi",
    madat: "Madat",
  },
  हिंदी: {
    appName: "Agro Madat", tagline: "किसान का सच्चा साथी",
    login: "लॉग इन", signup: "रजिस्टर करें", logout: "लॉग आउट", demo: "डेमो देखें",
    email_phone: "फ़ोन नंबर या ईमेल", password: "पासवर्ड", name: "पूरा नाम",
    google: "Google से जारी रखें", or: "या", welcome: "वापसी पर स्वागत है",
    createAccount: "खाता बनाएं", dashboard: "डैशबोर्ड", land: "भूमि मानचित्रण",
    crops: "फसल पुस्तकालय", operations: "खेती कार्य", planning: "भविष्य योजना",
    resources: "मदत साथी", inventory: "भंडार", accounting: "लेखा",
    equipment: "उपकरण", weather: "मौसम", market: "मंडी भाव", satellite: "सैटेलाइट व NDVI",
    analytics: "विश्लेषण", ai: "AI कृषि सलाहकार", documents: "दस्तावेज़", crm: "फार्म CRM",
    schemes: "सरकारी योजनाएं", team: "टीम व भूमिका", export: "निर्यात केंद्र", profile: "प्रोफ़ाइल",
    overview: "अवलोकन", landCrops: "भूमि व फसल", resFinance: "संसाधन व वित्त",
    intelligence: "बुद्धिमत्ता", admin: "प्रशासन", totalArea: "कुल क्षेत्र", activeCrops: "सक्रिय फसलें",
    netPL: "शुद्ध लाभ/हानि", avgNdvi: "औसत फसल स्वास्थ्य", goodMorning: "नमस्ते",
    search: "खोजें...", addField: "खेत जोड़ें", startCycle: "फसल चक्र शुरू करें",
    logActivity: "कार्य दर्ज करें", askAi: "अपने सहायक से पूछें…", send: "भेजें",
    acrossFields: "आपके खेतों में", growingNow: "अभी उग रही", thisSeason: "इस सीजन",
    fieldHealthIdx: "फसल स्वास्थ्य सूचकांक", cashflow: "नकदी प्रवाह", last6Months: "पिछले 6 महीने",
    incomeVsExpense: "आय बनाम खर्च", income: "आय", expense: "खर्च",
    soilDistribution: "मिट्टी वितरण", acresBySoil: "मिट्टी प्रकार अनुसार एकड़",
    activeCropCycles: "सक्रिय फसल चक्र", viewAll: "सभी देखें", alertsTasks: "चेतावनी व कार्य",
    yourCropsLive: "आपकी फसलें — मंडी भाव", todaysBestRate: "आज आपकी फसलों का सर्वोत्तम भाव",
    liveLabel: "लाइव", sampleLabel: "नमूना", noRateToday: "आज भाव उपलब्ध नहीं", lastPrice: "अंतिम भाव",
    mandiWatch: "मंडी निगरानी", sevenDay: "7-दिन", agriNews: "कृषि समाचार", loadingWeather: "मौसम लोड हो रहा…",
    loadingPrices: "भाव लोड हो रहे…", humidity: "आर्द्रता", wind: "हवा", rain: "बारिश",
    cropSuitability: "फसल उपयुक्तता", rotation5yr: "5-वर्षीय चक्र", seasonalTab: "इस सीजन",
    longTermTab: "दीर्घकालीन", scoringCrops: "फसलों का आकलन…", costAcre: "लागत/एकड़", estProfit: "अनुमानित लाभ",
    duration: "अवधि", months: "माह", marketRisk: "बाज़ार जोखिम", riskLow: "कम", riskMedium: "मध्यम",
    riskHigh: "अधिक", perennialNote: "बहुवर्षीय — एक बार रोपण", nextService: "अगली सर्विस",
    hrsToService: "घंटे सर्विस तक", mspBacked: "MSP समर्थित",
    fasalDoctor: "फ़सल डॉक्टर", herbTrace: "जड़ी-बूटी ट्रेसिंग", sinchai: "सिंचाई सलाहकार",
    khaad: "खाद कैलकुलेटर", simulator: "मुनाफ़ा सिम्युलेटर", pmfby: "PMFBY क्लेम",
    echarak: "जड़ी-बूटी (e-Charak)", mandiTab: "मंडी", offlineMode: "ऑफलाइन मोड — सहेजा डेटा दिखा रहे हैं", backOnline: "फिर ऑनलाइन",
    cropProblems: "समस्या कैलेंडर",
    sprayCheck: "छिड़काव सुरक्षा",
    reportEvent: "दिक्कत बताएँ",
    madatSaathi: "मदत साथी",
    madat: "मदत",
  },
  Hinglish: {
    appName: "Agro Madat", tagline: "Kisan ka saathi, har kadam par saath",
    login: "Log in", signup: "Sign up", logout: "Log out", demo: "Demo dekhein",
    email_phone: "Phone number ya Email", password: "Password", name: "Pura naam",
    google: "Google se continue karein", or: "ya", welcome: "Wapas aane par swagat",
    createAccount: "Account banayein", dashboard: "Dashboard", land: "Land Mapping",
    crops: "Crop Library", operations: "Operations", planning: "Future Planning",
    resources: "Madat Saathi", inventory: "Inventory", accounting: "Accounting",
    equipment: "Equipment", weather: "Mausam", market: "Mandi Bhav", satellite: "Satellite & NDVI",
    analytics: "Analytics", ai: "AI Agronomist", documents: "Documents", crm: "Farm CRM",
    schemes: "Govt Schemes", team: "Team & Roles", export: "Export Center", profile: "Profile",
    overview: "Overview", landCrops: "Land & Crops", resFinance: "Resources & Finance",
    intelligence: "Intelligence", admin: "Admin", totalArea: "Total Area", activeCrops: "Active Crops",
    netPL: "Net Profit/Loss", avgNdvi: "Avg Field Health", goodMorning: "Namaste",
    search: "Search...", addField: "Add Field", startCycle: "Crop Cycle shuru karein",
    logActivity: "Activity log karein", askAi: "Apne assistant se poochein…", send: "Bhejein",
    acrossFields: "aapke kheton mein", growingNow: "abhi ug rahi", thisSeason: "is season",
    fieldHealthIdx: "fasal health index", cashflow: "Cashflow", last6Months: "Pichhle 6 mahine",
    incomeVsExpense: "Aay vs Kharch", income: "Aay", expense: "Kharch",
    soilDistribution: "Mitti Distribution", acresBySoil: "Mitti type ke hisaab se acre",
    activeCropCycles: "Active Crop Cycles", viewAll: "Sabhi dekhein", alertsTasks: "Alerts & Tasks",
    yourCropsLive: "Aapki Fasalein — Mandi Bhav", todaysBestRate: "Aaj aapki fasalon ka best bhav",
    liveLabel: "Live", sampleLabel: "Sample", noRateToday: "Aaj bhav uplabdh nahi", lastPrice: "Antim bhav",
    mandiWatch: "Mandi Watch", sevenDay: "7-din", agriNews: "Krishi News", loadingWeather: "Mausam load ho raha…",
    loadingPrices: "Bhav load ho rahe…", humidity: "Humidity", wind: "Hawa", rain: "Barish",
    cropSuitability: "Fasal Suitability", rotation5yr: "5-Saal Rotation", seasonalTab: "Is Season",
    longTermTab: "Long-term", scoringCrops: "Fasalon ka scoring…", costAcre: "Lagat/acre", estProfit: "Est. profit",
    duration: "Avadhi", months: "mah", marketRisk: "Market risk", riskLow: "Kam", riskMedium: "Madhyam",
    riskHigh: "Adhik", perennialNote: "Perennial — ek baar ropan", nextService: "Agli service",
    hrsToService: "ghante service tak", mspBacked: "MSP-backed",
    fasalDoctor: "Fasal Doctor", herbTrace: "Herb Trace", sinchai: "Sinchai Salahkar",
    khaad: "Khaad Calc", simulator: "Profit Simulator", pmfby: "PMFBY Claim",
    echarak: "Herbs (e-Charak)", mandiTab: "Mandi", offlineMode: "Offline mode — saved data", backOnline: "Wapas online",
    cropProblems: "Problem Calendar",
    sprayCheck: "Spray Safety",
    reportEvent: "Report Issue",
    madatSaathi: "Madat Saathi",
    madat: "Madat",
  },
};

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("am_theme") || "light");
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("am_lang");
    if (saved) return saved;
    const loc = (navigator.language || "en").toLowerCase();
    return loc.startsWith("hi") ? "हिंदी" : "English";
  });
  const [activeFarm, setActiveFarm] = useState(null);
  const [online, setOnline] = useState(navigator.onLine);
  const [tourOpen, setTourOpen] = useState(false);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("am_theme", theme);
  }, [theme]);

  useEffect(() => {
    const isHi = language === "हिंदी";
    document.documentElement.classList.toggle("lang-hi", isHi);
    document.documentElement.setAttribute("lang", isHi ? "hi" : "en");
    localStorage.setItem("am_lang", language);
  }, [language]);

  const t = useCallback((key) => (STR[language] && STR[language][key]) || STR.English[key] || key, [language]);

  return (
    <AppContext.Provider value={{ theme, setTheme, language, setLanguage, t, activeFarm, setActiveFarm, online, tourOpen, setTourOpen }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
